<template>
  <b-modal :id="`reported-issue-modal-${id}`" :no-close-on-backdrop="true" @show="show">
    <div class="p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="title-lg">{{ $t('reported-issue-id', { id }) }}</div>
        <div>
          <img
            src="@/assets/images/icons/cross-icon.svg"
            alt="cross-icon"
            class="cursor-pointer"
            height="15px"
            @click="close"
          />
        </div>
      </div>

      <div>
        <div class="row">
          <div class="col">
            <b-alert :show="error && error.length ? true : false" variant="danger">
              <div v-if="Array.isArray(error)">
                <div
                  class="d-flex flex-column my-1"
                  v-for="(error_text, index) in error"
                  :key="index"
                >
                  {{ error_text }}
                </div>
              </div>
              <div v-else>
                <div v-html="error || '&nbsp;'"></div>
              </div>
            </b-alert>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <base-input
              type="text"
              label="driver"
              name="Driver"
              placeholder="driver"
              field="driver"
              id="reported-issue-modal-driver"
              :value="driver"
              :disabled="true"
              @change-value="setValue"
            ></base-input>
          </div>
          <div class="col-md-6 col-sm-12">
            <base-input
              type="text"
              label="journey-id"
              name="Journey ID"
              placeholder="journey-id"
              field="journey_id"
              id="reported-issue-modal-journey_id"
              :value="journey_id"
              :disabled="true"
              @change-value="setValue"
            ></base-input>
          </div>
          <div class="col-md-6 col-sm-12">
            <base-input
              type="text"
              label="title"
              name="Title"
              placeholder="title"
              field="title"
              id="reported-issue-modal-title"
              :value="title"
              :disabled="true"
              @change-value="setValue"
            ></base-input>
          </div>
          <div class="col-md-6 col-sm-12">
            <base-input
              type="text"
              label="details"
              name="Details"
              placeholder="details"
              field="details"
              id="reported-issue-modal-details"
              :value="details"
              :disabled="true"
              @change-value="setValue"
            ></base-input>
          </div>
          <div class="col-md-12 col-sm-12">
            <base-textarea
              label="action-taken"
              name="action taken"
              placeholder="enter-action-taken"
              field="action_taken"
              id="reported-issue-modal-action_taken"
              :value="action_taken"
              :disabled="loading"
              @change-value="setValue"
            ></base-textarea>
          </div>
        </div>
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-5 col-md-6 col-sm-12 mb-3">
            <base-button
              id="reported-issue-modal-resolve-btn"
              variant="primary"
              :disabled="!action_taken || loading"
              :loading="loading"
              @click="resolve"
            >
              {{ $t('resolve') }}
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { socket } from '@/socket'
import ReportService from '@/services/report.service'

export default {
  props: ['id', 'data'],
  emits: ['refreshData'],
  data() {
    return {
      loading: false,
      error: null,
      driver: null,
      journey_id: null,
      title: null,
      details: null,
      action_taken: null,
      assigned_to: null,
    }
  },
  methods: {
    close() {
      this.loading = true
      this.error = null
      ReportService.put({}, `${this.id}/dismiss-report`)
        .then(() => {
          this.$emit('refreshData')
          this.$bvModal.hide(`reported-issue-modal-${this.id}`)
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    resolve() {
      this.loading = true
      this.error = null

      ReportService.put({ actionTaken: this.action_taken }, `${this.id}/resolve-report`)
        .then(() => {
          this.$emit('refreshData')
          this.$bvModal.hide(`reported-issue-modal-${this.id}`)
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    setValue(val, field) {
      this[field] = val
    },
    show() {
      socket.emit('is-opened', this.id)
      if (this.data?.driver)
        this.driver = this.isLangRtl ? this.data.driver.arabicName : this.data.driver.name || ''
      if (this.data?.trip?._id) this.journey_id = this.data.trip._id
      if (this.data?.reason) this.title = this.data.reason
      if (this.data?.comments) this.details = this.data.comments
      if (this.data?.assignedTo) this.assigned_to = this.data.assignedTo
    },
    leaving() {
      socket.emit('is-closed', {
        id: this.id,
        assignedTo: this.$store.getters['enums/user_info'].userID,
      })
    },
  },
  created() {
    window.addEventListener('beforeunload', this.leaving)
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/reportedIssues.json'),
      ar: require('@/services/i18n/locales/ar/reportedIssues.json'),
    },
  },
}
</script>
